import { Navigate, useLocation } from 'react-router-dom';

interface SectionRedirectProps {
  /** Absolute path of the section's default page, e.g. `/report/overview`. */
  to: string;
}

/**
 * Redirects a section's bare path (e.g. `/report`) to its default child page
 * (e.g. `/report/overview`), preserving any query string. Rendered from a
 * pathless index route so the redirect is declared next to the section it
 * belongs to, instead of as cross-cutting `if (pathname === …)` checks in a
 * shared layout.
 */
export function SectionRedirect({ to }: SectionRedirectProps) {
  const { search } = useLocation();

  return <Navigate to={`${to}${search}`} replace />;
}
